import React from 'react';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';

function FreeZoneRegulationsTwoCards({ id, data }) {
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const cards = _.get(data, 'cards', []);

  return (
    <section id={id} className="py-12.5 bg-white">
      <BoxedContainer>
        <div className="w-full grid grid-cols-6 lg:grid-cols-12 gap-14 lg:gap-16">
          <div className="col-span-6 lg:col-span-12 flex flex-col items-center gap-5">
            <div
              className="child:text-clamp20to40 child:ltr:!font-URWDINRegular 
              child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3] last:child:!m-0
              child:text-center"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div className="py-px bg-red w-10 lg:w-12.5" />
            <div
              className="child:text-clamp12to18 child:ltr:!font-URWDINRegular 
              child:rtl:!font-GESSTwoDWTCLight child:leading-1.4
              last:child:!m-0 child:text-center"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
          <div className="col-span-6 lg:col-span-12 grid grid-cols-6 lg:grid-cols-12 gap-5">
            {_.map(cards, (card, index) => {
              const cardTitle = _.get(card, 'content.title', '');
              const cardText = _.get(card, 'content.text', '');
              const cardImage = _.get(card, 'content.image', '');
              const cardFile = _.get(card, 'content.file', '');

              return (
                <div key={index} className="col-span-6 md:col-span-3 lg:col-span-6 bg-desertStorm">
                  <div className="flex flex-col pt-7 pb-8 px-3.5 items-center gap-5">
                    <div className="flex flex-col items-center gap-4">
                      <div
                        className="child:text-clamp20to25 child:ltr:!font-URWDINMedium 
                        child:rtl:!font-GESSTwoDWTCLight child:leading-[1.6]
                        last:child:!m-0 child:text-center"
                        dangerouslySetInnerHTML={{ __html: cardTitle }}
                      />
                      <div
                        className="child:text-clamp12to16 child:ltr:!font-URWDINRegular 
                        child:rtl:!font-GESSTwoDWTCLight child:leading-[1.6]
                        last:child:!m-0 child:text-center"
                        dangerouslySetInnerHTML={{ __html: cardText }}
                      />
                    </div>
                    <a
                      href={cardFile?.url}
                      download
                      className="text-white bg-red py-2.5 px-10 flex w-fit gap-6 rounded-full
                      uppercase tracking-widest">
                      Download
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none">
                        <path
                          d="M11 12.4811L9.02444 10.5067M11 12.4811L12.9756 10.5067M11
                          12.4811V6.55556M15.4444 13.4689C15.4444 13.9928 15.2363 14.4953 14.8658
                          14.8658C14.4953 15.2363 13.9928 15.4444 13.4689 15.4444H8.53111C8.00716
                          15.4444 7.50467 15.2363 7.13418 14.8658C6.76369 14.4953 6.55556 13.9928
                          6.55556 13.4689M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228
                          1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                  {_.isEmpty(cardImage) || (
                    <LazyLoadImage
                      src={cardImage?.url}
                      alt={cardTitle}
                      className="w-full !max-h-64 object-cover"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneRegulationsTwoCards;
